import coordinator from "../../img/team/2019/coordinator.jpg";
import newhod from "../../img/team/2019/newhod.jpeg";
import president from "../../img/team/2026/atharva.jpeg";
import vicePresident from "../../img/team/2026/tanushri.jpg";
import techLead1 from "../../img/team/2026/suraj.jpeg";
import techLead2 from "../../img/team/2026/shreya.jpeg";
import financeHead2 from "../../img/team/2026/anurag.jpeg";
import financeHead1 from "../../img/team/2026/samruddhi2.jpeg";
import eventHead1 from "../../img/team/2026/shreyas.png";
import eventHead2 from "../../img/team/2026/advait.jpeg";
import creativesHead1 from "../../img/team/2026/divyam.png";
import creativesHead2 from "../../img/team/2026/mehandi.jpeg";

const team2026 = [
  {
    post: [
      {
        initial: "Dr.",
        name: "P. K.",
        surname: "Deshmukh",
        desc: "Head, Department of Computer Science and Engineering",
        image: newhod,
        mail: "mailto:hod.comp@coep.ac.in",
        about: "https://www.coep.org.in/departments/computerit/aboutdep",
      },
      {
        initial: "Dr.",
        name: "Amit",
        surname: "Joshi",
        desc: "CSI COEP Tech Student Chapter Coordinator",
        image: coordinator,
        mail: "mailto:adj.comp@coep.ac.in",
        about: "https://www.coep.org.in/mycoep/adjcompcoepacin",
      },
    ],
  },
  {
    post: [
      {
        name: "Atharva",
        surname: "Wadekar",
        position: "President",
        image: president,
        linkedin: "https://linkedIn.com/in/atharvamw",
        github: "https://github.com/atharvamw",
      },
      {
        name: "Tanushri",
        surname: "Jadhav",
        position: "Vice President",
        image: vicePresident,
        linkedin: "https://www.linkedin.com/in/tanushri-jadhav-08732732b",
        github: "https://github.com/tanushrijadhav",
      },
    ],
  },
  {
    post: [
      {
        name: "Suraj",
        surname: "Wakhure",
        position: "Technical Head",
        image: techLead1,
        linkedin: "https://www.linkedin.com/in/suraj-wakhure-864997262/",
        github: "https://github.com/Suraj-Wakhure",
      },
      {
        name: "Shreya",
        surname: "Janorkar",
        position: "Technical Head",
        image: techLead2,
        linkedin:
          "https://www.linkedin.com/in/shreya-janorkar-81bb0a35a?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        github: "https://github.com/shreyagpj",
      },
      {
        name: "Samruddhi",
        surname: "Ombase",
        position: "Finance Head",
        image: financeHead1,
        linkedin: "https://www.linkedin.com/in/samruddhi-ombase-849964331",
        github: "https://github.com/SamruddhiOmbase",
      },
      {
        name: "Anurag",
        surname: "De",
        position: "Finance Head",
        image: financeHead2,
        linkedin:
          "https://www.linkedin.com/in/anurag-de-bba661320?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        github: "https://github.com/AnuragDe-cloud",
      },
      {
        name: "Shreyas",
        surname: "Joshi",
        position: "Events & Publicity Head",
        image: eventHead1,
        linkedin:
          "https://www.linkedin.com/in/shreyas-joshi-829355318?utm_source=share_via&utm_content=profile&utm_medium=member_android",
        github: "https://github.com/Shreyas2608",
      },
      {
        name: "Advait",
        surname: "Gajewar",
        position: "Events & Publicity Head",
        image: eventHead2,
        linkedin: "https://www.linkedin.com/in/advait-gajewar/",
        github: "https://github.com/the0epicguy",
      },
      {
        name: "Divyam",
        surname: "Shah",
        position: "Design Head",
        image: creativesHead1,
        linkedin: "https://www.linkedin.com/in/divyam-shah-8a5700381/",
        github: "https://github.com/DVM106",
      },
      {
        name: "Mohd",
        surname: "Mehandi",
        position: "Design Head",
        image: creativesHead2,
        linkedin: "https://www.linkedin.com/in/mohd-mehandi-bb5204375/",
        github: "https://github.com/thecodex110",
      },
    ],
  },
];

export default team2026;
